import React, { Fragment, useEffect, useState } from "react";
import {
  announcementUserTransaction,
  getUserAnnouncement,
} from "../../services/announcementService";
import CloseIcon from "@mui/icons-material/Close";
import "./Announcements.scss";
import { Button, Modal } from "antd";
import { Dialog } from "@mui/material";
import { useSelector } from "react-redux";
import AppAuthSetup from "../AppAuth/AppAuthSetup";

const Announcements = () => {
  const appAuthAnnouncement = {
    attachments: [],
    description:
      "Reminder: Activate mandated app-based two-factor authentication for added security",
    id: "appAuthAnnouncement",
    type_name: "2FA using app-based TOTP",
  };
  const email = JSON.parse(localStorage.getItem("user") || "{}")?.email;

  const [announcements, setAnnouncements] = useState<any>([]);
  const [announcementList, setAnnouncementList] = useState<any>([]);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [showAppAuthSetup, setShowAppAuthSetup] = useState(false);
  const [confirmDialogVisible, setConfirmDialogVisible] = useState(false);
  const [currentAnnouncementId, setCurrentAnnouncementId] = useState(null);

  const companyPreferences = useSelector(
    (state: any) => state.org.companyPreferences
  );
  const userDetails = useSelector((state: any) => state.user.userDetails);

  const getUserAnnouncements = () => {
    getUserAnnouncement().then((res: any) => {
      setAnnouncements(res?.data?.length ? res.data : []);
    });
  };

  const checkAndAddAuthAnnouncement = () => {
    const finalAnnouncement = [...announcements];
    console.log(finalAnnouncement);
    if (companyPreferences.app_auth_enabled && !userDetails.appAuthSetup) {
      setAnnouncementList([appAuthAnnouncement, ...finalAnnouncement]);
    } else {
      setAnnouncementList([...finalAnnouncement]);
    }
  };

  useEffect(() => {
    checkAndAddAuthAnnouncement();
  }, [announcements]);

  useEffect(() => {
    if (
      Object.keys(companyPreferences).length > 0 &&
      Object.keys(userDetails).length > 0
    ) {
      setCurrentIndex(0);
      checkAndAddAuthAnnouncement();
    }
  }, [companyPreferences, userDetails]);

  useEffect(() => {
    getUserAnnouncements();
  }, []);

  const handleNextIndex = () => {
    if (currentIndex < announcementList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePreviousIndex = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const onClose = (currentId: any) => {
    setCurrentAnnouncementId(currentId);
    setConfirmDialogVisible(true);
  };

  const handleConfirmClose = () => {
    if (currentAnnouncementId) {
      announcementUserTransaction({ announcement: currentAnnouncementId })
        .then((res: any) => {
          console.log(res);
          if (currentIndex === announcementList.length - 1) {
            setCurrentIndex(0);
          }
          getUserAnnouncements();
        })
        .catch((error: any) => {
          console.log(error);
        });
    }

    setConfirmDialogVisible(false);
  };

  const handleCancelClose = () => {
    setConfirmDialogVisible(false);
  };

  return (
    <Fragment>
      <div>
        {announcementList?.length ? (
          <div className="flex flex-row py-4">
            {
              <button
                onClick={handlePreviousIndex}
                className={`pw-left-arrow ${
                  currentIndex === 0 ? "pw-hidden" : ""
                }`}
              >
                <img
                  src="assets/icons/arrow-left.svg"
                  alt=" "
                  className="pw-arrow"
                />
              </button>
            }
            <div className="w-full p-4 pw-announcements-banner flex-col  gap-4">
              <div
                key={announcementList[currentIndex].id}
                className="flex flex-col justify-between !min-h-16"
              >
                <div className="flex flex-row justify-between">
                  <div className="text-sm font-semibold font-['Proxima Nova']">
                    {announcementList[currentIndex].type_name || "-"}
                  </div>
                  {announcementList[currentIndex]?.id !==
                    "appAuthAnnouncement" && (
                    <div>
                      <img
                        src="assets/icons/close.svg"
                        alt=" "
                        className="cursor-pointer"
                        onClick={() => {
                          onClose(announcementList[currentIndex]?.id);
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="flex flex-row justify-between items-center min-h-10">
                  <div className="text-sm font-extralight font-['Proxima Nova']">
                    {announcementList[currentIndex].description}
                  </div>
                  {announcementList[currentIndex]?.id !==
                    "appAuthAnnouncement" &&
                    announcementList[currentIndex]?.attachments[0] && (
                      <Button
                        className="pw-bg-primary-color text-white"
                        onClick={() => {
                          const filePath =
                            announcementList[currentIndex]?.attachments[0]
                              ?.filePath;
                          if (filePath) {
                            window.open(filePath, "_blank");
                          }
                        }}
                      >
                        {"Download PDF"}
                      </Button>
                    )}
                  {announcementList[currentIndex]?.id ===
                    "appAuthAnnouncement" && (
                    <div
                      className="pw-setup-2FA-button !w-56"
                      onClick={() => {
                        setShowAppAuthSetup(true);
                      }}
                    >
                      Setup 2FA Configuration
                    </div>
                  )}
                </div>
              </div>
            </div>
            {
              <button
                onClick={handleNextIndex}
                className={`pw-right-arrow ${
                  currentIndex === announcementList.length - 1
                    ? "pw-hidden"
                    : ""
                }`}
              >
                <img
                  src="assets/icons/arrow-right-home-page.svg"
                  alt=" "
                  className="pw-arrow"
                />
              </button>
            }
          </div>
        ) : (
          ""
        )}
        <Modal
          title="Are you sure you want to close this announcement?"
          visible={confirmDialogVisible}
          onOk={handleConfirmClose}
          onCancel={handleCancelClose}
          footer={[
            <Button key="cancel" onClick={handleCancelClose}>
              Cancel
            </Button>,
            <Button
              key="confirm"
              type="primary"
              style={{ backgroundColor: "#59ce90", borderColor: "#52c41a" }}
              onClick={handleConfirmClose}
            >
              Confirm
            </Button>,
          ]}
        >
          <div className="mt-4 mb-8">
            Please note that it cannot be viewed further after closing.
          </div>
        </Modal>
      </div>
      {showAppAuthSetup && (
        <AppAuthSetup
          email={email}
          open={showAppAuthSetup}
          onClose={() => {
            setShowAppAuthSetup(false);
          }}
          fromLogin={false}
        />
      )}
    </Fragment>
  );
};

export default Announcements;
